import React from "react";
import { Button } from "antd";
import { textFormatting } from "../../utils/textFormatting";
import { useTypewriter } from "../../utils/useTypewriter"; // import the hook

export const HexiMessage = ({ text, options, onOptionClick, conversationDone, typewriterSpeed = 20 }) => {
  const displayedText = useTypewriter(text, typewriterSpeed); // hook usage

  return (
    <div className="speech-bubble hexilexi">
      <div style={{ position: 'relative' }}>
        {textFormatting(displayedText)}
        {/* You could also add a blinking cursor here */}
      </div>
      {options && options.length > 0 && (
        <div className="options-container">
          {options.map((opt, i) => (
            <Button
              key={i}
              className="option-btn"
              size="middle"
              onClick={() => onOptionClick(opt)}
              disabled={conversationDone}
              style={{ borderColor: '#9c27b0', color: '#9c27b0', background: 'white' }}
            >
              {opt}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};